import axios from "axios";
import app_config from "../../common/data/app_config";
import { getStorage } from "../../utilities/setting";
const axiosInstance = axios.create({
  baseURL: app_config.api_url,
});
axiosInstance.interceptors.request.use(
  async (req) => {
    let accessToken = "";
    if (!accessToken) {
      accessToken = getStorage("access_token")
        ? `Bearer ${getStorage("access_token")}`
        : "";
    }
    req.headers = {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: accessToken,
      "frontend-version": app_config.appVersion,
    };

    return req;
  },
  async (error) => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    if (error.response && error.response.status === 401) {
      if (window.location.pathname !== "/") {
        window.location.href = "/";
      }
    } else if (error.response && error.response.status === 403) {
      window.location.href = window.location.origin + "/auth/no-permission";
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
